import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import type { DiagramToothAndBridgeListViewItem } from '../../models';
import { IntuitiveIndication, treatmentListId, treatmentListOptionKey } from '../../models';
import { RxIntuitiveBridgeTreatmentViewlistItemComponent } from '../rx-intuitive-bridge-treatment-viewlist-item/rx-intuitive-bridge-treatment-viewlist-item.component';
import { RxIntuitiveToothTreatmentViewlistItemComponent } from '../rx-intuitive-tooth-treatment-viewlist-item/rx-intuitive-tooth-treatment-viewlist-item.component';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { TlkListboxComponent, TlkListboxOptionComponent } from '@itero/ui-toolkit-angular/listbox';
import { TlkCardComponent } from '@itero/ui-toolkit-angular/card';

@Component({
	selector: 'rx-intuitive-teeth-treatment-viewlist',
	templateUrl: './rx-intuitive-teeth-treatment-viewlist.component.html',
	styleUrls: ['./rx-intuitive-teeth-treatment-viewlist.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		TlkListboxComponent,
		TlkListboxOptionComponent,
		TlkCardComponent,
		RxIntuitiveToothTreatmentViewlistItemComponent,
		RxIntuitiveBridgeTreatmentViewlistItemComponent
	]
})
export class RxIntuitiveTeethTreatmentViewlistComponent extends BaseDestroyableComponent {
	readonly cardPadding = 16;

	@Input() treatmentListItems: readonly DiagramToothAndBridgeListViewItem[] = [];
	@Input() readOnly = false;

	@Output() clicked = new EventEmitter<number>();

	readonly selectedListOptionControl = new FormControl<string[]>([]);

	readonly optionKey = treatmentListOptionKey;

	isBridge(item: DiagramToothAndBridgeListViewItem): boolean {
		return item.bridgeIndex !== undefined;
	}

	isItemClickDisabled(item: DiagramToothAndBridgeListViewItem): boolean {
		return this.readOnly && item.indicationId === IntuitiveIndication.SupportingTooth;
	}

	onItemClick(item: DiagramToothAndBridgeListViewItem): void {
		if (this.isItemClickDisabled(item)) {
			return;
		}

		this.clicked.emit(treatmentListId(item));
	}

	trackByKey(index: number, item: DiagramToothAndBridgeListViewItem): string {
		return treatmentListOptionKey(item);
	}
}
